<template>
  <div class="list">
    <UtilityScroll
      :enabled="(displayedResults().length > 7 && showScroll)"
      height="379px"
    >
      <template v-if="type === 'news'">
        <a
          v-for="resultId in displayedResults()"
          :key="!resultId.loading && !resultId.empty ? resultId : 'LIST_ITEM_' + resultId.num"
          :class="['list__item', 'list__item--' + type, 'link--blank']"
          :href="results && results.byId && results.byId[resultId] && results.byId[resultId].attributes && results.byId[resultId].attributes.url && results.byId[resultId].attributes.url.length > 0 && results.byId[resultId].attributes.licensed === true ? results.byId[resultId].attributes.url : 'javascript:void(0)'"
          :target="results && results.byId && results.byId[resultId] && results.byId[resultId].attributes && results.byId[resultId].attributes.url && results.byId[resultId].attributes.url.length > 0 && results.byId[resultId].attributes.licensed === true ? '_blank' : '_self'"
          @click="createRipple($event); !resultId.loading && !resultId.empty && results && results.byId && results.byId[resultId] && results.byId[resultId].attributes && results.byId[resultId].attributes.url && results.byId[resultId].attributes.url.length > 0 && results.byId[resultId].attributes.licensed === true ? clicked({ 'id': results.byId[resultId].id, 'hash': resultId, 'type': results.byId[resultId].type }) : false"
        >
          <div
            v-for="field in fields"
            :key="field.key"
            :class="['list__field', 'list__field--' + (field.group ? field.group + '_' : '') + field.key]"
          >
            <div
              v-if="resultId.loading"
              class="list__skeleton"
              :style="{ width: (Math.floor(Math.random() * 45) + 35) + '%' }"
            />

            <div
              v-if="!resultId.loading && !resultId.empty && field.icon"
              :class="['list__icon', 'list__icon--' + field.iconSize]"
              :content="field.name"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
              v-html="field.icon"
            />

            <div
              v-if="!resultId.loading && !resultId.empty && field.tooltip"
              class="list__text"
              :content="getValue(resultId, field.tooltip, field.group, true)"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
              v-html="highlight(getValue(resultId, field.key, field.group ? field.group : false, false), highlightedWords)"
            />

            <div
              v-else-if="!resultId.loading && !resultId.empty && field.key !== 'url' && results && results.byId && results.byId[resultId] && results.byId[resultId].attributes && results.byId[resultId].attributes.url && results.byId[resultId].attributes.url.length > 0 && results.byId[resultId].attributes.licensed !== true"
              class="list__text"
              content="Unlock the news with Statzon subscription."
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
              v-html="highlight(getValue(resultId, field.key, field.group ? field.group : false, false), highlightedWords)"
            />

            <div
              v-else-if="!resultId.loading && !resultId.empty && field.key !== 'url'"
              class="list__text"
              v-html="highlight(getValue(resultId, field.key, field.group ? field.group : false, false), highlightedWords)"
            />
          </div>
        </a>
      </template>

      <template v-else>
        <router-link
          v-for="resultId in displayedResults()"
          :key="!resultId.loading && !resultId.empty ? resultId : 'LIST_ITEM_' + resultId.num"
          :is="!resultId.loading && !resultId.empty ? 'router-link' : 'span'"
          :to="!resultId.loading && !resultId.empty ? '/' + results.byId[resultId].type + '/' + results.byId[resultId].id : '#'"
          :class="['list__item', 'list__item--' + type, 'link--blank']"
          @click.native="createRipple($event); clicked({ 'id': results.byId[resultId].id, 'hash': resultId, 'type': results.byId[resultId].type })"
        >
          <div
            v-for="field in fields"
            :key="field.key"
            :class="['list__field', 'list__field--' + (field.group ? field.group + '_' : '') + field.key]"
          >
            <div
              v-if="resultId.loading"
              class="list__skeleton"
              :style="{ width: (Math.floor(Math.random() * 45) + 35) + '%' }"
            />

            <div
              v-if="!resultId.loading && !resultId.empty && field.key === 'status' && (getValue(resultId, 'downloaded', false, false) !== '-' || getValue(resultId, 'viewed', false, false) !== '-')"
              class="list__icon list__icon--md list__icon--blue"
              :content="(getValue(resultId, 'downloaded', false, false) !== '-' ? 'Last downloaded @ ' : 'Last viewed @ ') + formatDate(getValue(resultId, getValue(resultId, 'downloaded', false, false) !== '-' ? 'downloaded' : 'viewed', false, false))"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
            >
              <svg v-if="getValue(resultId, 'downloaded', false, false) !== '-'" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/></svg>
              <svg v-else-if="getValue(resultId, 'viewed', false, false) !== '-'" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"/></svg>
            </div>

            <div
              v-if="!resultId.loading && !resultId.empty && field.icon"
              :class="['list__icon', 'list__icon--' + field.iconSize]"
              :content="field.name"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
              v-html="field.icon"
            />

            <div
              v-if="!resultId.loading && !resultId.empty && field.tooltip"
              class="list__text"
              :content="getValue(resultId, field.tooltip, field.group, true)"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
              v-html="highlight(getValue(resultId, field.key, field.group ? field.group : false, false), highlightedWords)"
            />

            <div
              v-else-if="!resultId.loading && !resultId.empty && field.key !== 'url' && field.key !== 'status'"
              class="list__text"
              v-html="highlight(getValue(resultId, field.key, field.group ? field.group : false, false), highlightedWords)"
            />
          </div>
        </router-link>
      </template>
    </UtilityScroll>
  </div>
</template>

<script>
import UtilityScroll from '@/components/utility/Scroll.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    UtilityScroll
  },
  props: {
    type: {
      type: String
    },
    results: {
      type: Object
    },
    fields: {
      type: Array
    },
    showScroll: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    highlightedWords () {
      let words = []
      let getter = this.$store.getters['search/getSelectedFilters']

      Object.keys(getter).forEach(function (filters) {
        if (getter[filters] && getter[filters].length > 0) {
          getter[filters].forEach(function (filter) {
            words.push(filter.attributes.name)
          })
        }
      })

      return words
    }
  },
  methods: {
    clicked (value) {
      let name = this.results.byId[value.hash].attributes.title ? this.results.byId[value.hash].attributes.title : (this.results.byId[value.hash].attributes.name ? this.results.byId[value.hash].attributes.name : value.id)
      if (name && name !== '') {
        this.sendGoogleAnalyticsEvent('document_' + value.type + '_open', name, 'list', this.$store.getters['user/getSubscriptionStatus'])
      }
      this.$emit('clicked', value)
    },
    displayedResults () {
      let displayedResults = []
      let displayable = (this.results && this.results.allIds && this.results.allIds.length <= 24) ? this.results.allIds.length : 24

      if (this.loading) {
        displayable = 24

        if (this.$route.name === 'Search') {
          displayable = 10
        }
      }

      if (this.$route.name === 'Search' && displayable > 10) {
        displayable = 10
      }

      for (let i=0; i<displayable; i++) {
        if (!this.loading && this.results && this.results.allIds[i]) {
          displayedResults.push(this.results.allIds[i])
        } else if (this.loading) {
          displayedResults.push({ 'loading': true, 'num': '_' + i })
        } else {
          displayedResults.push({ 'empty': true, 'num': '_' + i })
        }
      }

      return displayedResults
    },
    getValue (resultId, field, group, tooltip) {
      let value = '-'

      if (group && this.results && this.results.byId && this.results.byId[resultId].attributes[group] && this.results.byId[resultId].attributes[group][0] && this.results.byId[resultId].attributes[group][0].attributes[field] && this.results.byId[resultId].attributes[group][0].attributes[field].length > 0) {
        value = this.results.byId[resultId].attributes[group][0].attributes[field]
      } else if (this.results && this.results.byId && this.results.byId[resultId].attributes[field] && this.results.byId[resultId].attributes[field].length > 0) {
        value = this.results.byId[resultId].attributes[field]
      }

      if (field === 'created_at' || field === 'posted_on') {
        value = tooltip ? new Date(value).toUTCString() : new Date(value).toDateString()
      }

      return value
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.list {
  @include font('content--sm', $white, 0.55);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color: $bg-4;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--md', $white, 0.55);
  }

  &--slider {
    height: 379px;
    overflow: auto;

    @media screen and (min-width: $breakpointMd) {
      height: 379px;
    }

    @media screen and (min-width: $breakpointLg) {
      height: 399px;
    }
  }

  &__skeleton {
    width: 75%;
    height: 12px;
    border-radius: 2px;
    //background-color: rgba($white, 0.1);
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-lines 2s infinite ease-out;

    &--right {
      float: right;
    }
  }

  &__item {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: calc(100% - 32px);
    min-height: 20px;
    height: auto;
    padding: 8px 16px;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    @media screen and (min-width: $breakpointLg) {
      min-height: 22px;
    }

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: $bg-2;
      cursor: pointer;

      div {
        color: $blue;
      }
    }

    /*&:active, &:focus {
      background-color: lighten($bg-4, 5);

      div {
        color: $blue;
      }
    }*/
  }

  &__field {
    display: flex;
    align-items: center;
    justify-content: left;

    &--title {
      min-width: 260px;
      flex: 1;
      color: $white;
    }

    &--name {
      min-width: 220px;
      max-width: 220px;
      color: $white;

      @media screen and (min-width: $breakpointMd) {
        min-width: 260px;
        max-width: 260px;
      }
    }

    &--publisher {
      max-width: 240px;
      padding-left: 24px;
      display: none;

      @media screen and (min-width: $breakpointSm) {
        display: block;
      }

      @media screen and (min-width: $breakpointMd) {
        max-width: 320px;
      }
    }

    &--locations_code {
      width: 32px;
      padding-left: 32px;
      color: rgba($white, 0.9);

      @media screen and (max-width: 960px) {
        display: none;
      }

      @media screen and (min-width: $breakpointLg) {
        padding-left: 40px;
      }
    }

    &--short_description {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 16px;
    }

    &--employee_range {
      max-width: 120px;
      justify-content: right;
      padding-left: 32px;
      color: rgba($white, 0.9);

      @media screen and (max-width: $breakpointMd) {
        display: none;
      }

      @media screen and (min-width: $breakpointLg) {
        padding-left: 40px;
      }
    }

    &--providers_name {
      max-width: 180px;
      padding-left: 40px;

      @media screen and (max-width: $breakpointMd) {
        display: none;
      }

      @media screen and (min-width: $breakpointLg) {
        padding-left: 48px;
        max-width: 220px;
      }
    }

    &--created_at, &--posted_on {
      justify-content: right;
      min-width: 120px;
      max-width: 120px;
      padding-left: 16px;
      color: rgba($white, 0.9);

      @media screen and (max-width: 720px) {
        display: none;
      }

      @media screen and (min-width: $breakpointLg) {
        padding-left: 24px;
      }
    }
  }

  &__icon {
    fill: rgba($white, 0.3);

    &--blue {
      fill: rgba($blue, 0.9);
    }

    &--md {
      width: 16px;
      min-width: 16px;
      height: 16px;
      margin-right: 8px;

      @media screen and (min-width: $breakpointLg) {
        width: 18px;
        height: 18px;
      }
    }

    &--lg {
      width: 18px;
      min-width: 18px;
      height: 18px;
      margin-right: 8px;

      @media screen and (min-width: $breakpointLg) {
        width: 20px;
        height: 20px;
      }
    }
  }

  &__text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@keyframes wave-lines {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

</style>
